import React, { useState } from "react";
import { Parallax } from "react-scroll-parallax";
import "./Fundraising.css";

const fundraisingAvenues = [
  {
    title: "Original Works",
    description: "Throughout the year, we offer opportunities to purchase keepsakes featuring your child's artwork.",
  },
  {
    title: "Binkley Events",
    description: "Join some of our fundraising events throughout the year, like our Dinner Nights and our Family Picnics.",
  },
  {
    title: "Holiday Greenery",
    description: "Get into the holiday spirit while supporting Binkley by purchasing wreaths, centerpieces, and more.",
  }
];

const Fundraising = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="fundraising-page">
      {/* Hero Section */}
      <section className="fundraising-hero" aria-label="Fundraising hero section">
        <div className="fundraising-hero-overlay"></div>
        <div className="fundraising-hero-text">
          <h1>Fundraising</h1>
          <p>
            Binkley Preschool is a place where little learners grow, play, and shine. We believe learning is a joyful experience, and we are honored to nurture that curiosity. 
            <br/><br/>
            As a 501(c)(3) nonprofit preschool, the extra support from our beautiful Binkley community helps us add extra spark: scholarships, fun events, and enriched learning experiences.
          </p>
          <button className="donate-button" onClick={openModal}>
            Donate Now
          </button>
        </div>
      </section>

      {/* Nonprofit Info */}
      <section className="nonprofit-info">
        <div className="nonprofit-text">
          <h2>Our Fundraising Efforts</h2>
          <p>
            Every contribution, whether it’s a donation, joining a fundraiser, or giving your time as a volunteer, helps us keep tuition affordable, expand our scholarship program, and give our teachers the resources they need to help each child thrive.
            <br/><br/>
            Throughout the year, we host a variety of fundraisers designed to engage and build our community. Some offer beautiful keepsakes that capture memories from your child’s preschool years, perfect for family and friends. We also host special events, which not only help raise funds, but also bring families together and strengthen the welcoming, connected community that makes Binkley so unique!
            <br/><br/>
            When you share your time or resources with Binkley, you’re helping little hands and big hearts discover the joy of learning. Thank you for being part of our story!
          </p>
        </div>

        {/* Fundraising Avenues */}
        <div className="avenue-cards">
          {fundraisingAvenues.map((avenue, index) => (
            <Parallax key={index} speed={5}>
              <div className="avenue-card">
                <h3>{avenue.title}</h3>
                <p>{avenue.description}</p>
              </div>
            </Parallax>
          ))}
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal} role="dialog" aria-modal="true" aria-label="Donation modal">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal} aria-label="Close modal">
              &times;
            </button>
            <h2>Support Binkley Preschool</h2>
            <p>
              Thank you for your generosity! Our PayPal is coming soon. 
              For now, please reach out to us directly if you'd like to donate.
            </p>
            <p>
              <em>Email: director@binkleypreschool.org</em>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Fundraising;
